import axios from '@/axios'

export default {
  getData (options = {}) {
    return axios.get('/campaign', options)
  },
  getPM(options = {}) {
  	return axios.get('/terima-manfaat', options)
  },
  requestPM(data, options) {
  	return axios.post('/input/terima-manfaat', data, options)
  },
  getCategory(options) {
    return axios.get('/kategori-campaign', options)
  },
  getDetail(options) {
    return axios.get(`/campaign/${options.id}`, options)
  }
}